import { PageInfo, PageManager } from './state';

export const getters = {
	getCurrentPage(state: PageManager): PageInfo {
		return state.pages[state.pages.length - 1];
	},
};
